export type SettingsCrudAction = 'add' | 'update' | 'detail';

export interface SettingsCrudRoute {
    action: SettingsCrudAction | null;
    id: number | null;
}

const VALID_ACTIONS: SettingsCrudAction[] = ['add', 'update', 'detail'];

export const buildSettingsBasePath = (subpage: string): string => {
    return `/settings/${subpage}`;
};

export const buildSettingsCrudPath = (subpage: string, action: SettingsCrudAction, id?: number | string): string => {
    const basePath = buildSettingsBasePath(subpage);
    if (action === 'add') {
        return `${basePath}/add`;
    }

    if (id === undefined || id === null || id === '') {
        return basePath;
    }

    return `${basePath}/${action}/${id}`;
};

export const parseSettingsCrudRoute = (pathname: string, subpage: string): SettingsCrudRoute => {
    const segments = pathname.split('/').filter(Boolean);
    if (segments[0] !== 'settings' || segments[1] !== subpage) {
        return { action: null, id: null };
    }

    const action = segments[2] as SettingsCrudAction | undefined;
    if (!action || !VALID_ACTIONS.includes(action)) {
        return { action: null, id: null };
    }

    if (action === 'add') {
        return { action, id: null };
    }

    const rawId = segments[3];
    if (!rawId || !/^\d+$/.test(rawId)) {
        return { action, id: null };
    }

    return { action, id: Number(rawId) };
};
